import { chatApiUrls } from 'constants/apiEndPoints';
import ApiUtil from '../utils/ApiUtil';
import { type ChatMessagesAttributesType, type ConversationAttributesType, type addChatConversationType } from 'types/services';
import QueryParamsBuilder from 'components/helpers/commonFunctions/QueryParamsBuilder';



const createChatConversation = async (data: ChatMessagesAttributesType): Promise<ConversationAttributesType> => {
    return await ApiUtil.postWithToken(chatApiUrls.createChatConversationUrl, data) as ConversationAttributesType;

}


const getAllConversation = async ({ page, size, sortBy, sortOrder, searchValue, filters }: {
    page: number;
    size: number;
    sortBy?: string;
    sortOrder?: string;
    searchValue?: string;
    filters?: unknown
}): Promise<ConversationAttributesType> => {
    let apiUrl = QueryParamsBuilder({ baseUrl: chatApiUrls.getAllConversationUrl, page, size, sortBy, sortOrder, searchValue });
    const filterParams = new URLSearchParams();
    if (filters) {
        if (filters.startDate) {
            filterParams.append('startDate', filters.startDate);
        }

        if (filters.endDate) {
            filterParams.append('endDate', filters.endDate);
        }

        if (filters.status) {
            const status = filters.status || '';
            filterParams.append('status', status);
        }
    }

    if (filterParams.toString()) {
        apiUrl += `&${filterParams.toString()}`;
    }

    return await ApiUtil.getWithToken(apiUrl) as ConversationAttributesType;


}
const getConversationById = async (userId: number): Promise<{ basicInfo: ConversationAttributesType }> => {

    return await ApiUtil.getWithToken(`${chatApiUrls.getConversationByIdUrl}/${userId}`) as { basicInfo: ConversationAttributesType };


}
const getConversationByConverId = async (userId: number, conversationId: number): Promise<ConversationAttributesType> => {
    return await ApiUtil.getWithToken(`${chatApiUrls.getConversationByConverIdUrl}/${userId}/${conversationId}`) as ConversationAttributesType;

}


const readChatConversation = async (userId: number): Promise<string> => {
    try {
        const isRead = true
        await ApiUtil.putWithToken(`${chatApiUrls.readChatConversationUrl}/${userId}`, { isRead });
        return 'Successfully readed';
    } catch (error) {
        throw new Error(`Unable to read employee. ${String(error)}`);
    }
};

const getAllMessagesByConversationId = async (conversationId: number): Promise<ChatMessagesAttributesType> => {

    return await ApiUtil.getWithToken(`all-conversations/${conversationId}`) as ChatMessagesAttributesType;


}


const updateConversationStatus = async (conversationId: number, data: { status: string, userId: number }): Promise<string> => {

    try {
        await ApiUtil.putWithToken(`${chatApiUrls.updateConversationStatusUrl}/${conversationId}`, data);
        return 'Successfully status updated ';
    } catch (error) {
        throw new Error(`Unable to change status. ${String(error)}`);
    }
};


const getAllChatByConversationId = async (conversationId: number): Promise<{ basicInfo: ChatMessagesAttributesType[] }> => {

    return await ApiUtil.getWithToken(`${chatApiUrls.getAllChatByConversationIdUrl}/${conversationId}`) as { basicInfo: ChatMessagesAttributesType[] };


}
const getAllChatByComplaintId = async (complaintId: number): Promise<ChatMessagesAttributesType> => {

    return await ApiUtil.getWithToken(`${chatApiUrls.getAllChatByComplaintIdUrl}/${complaintId}`) as ChatMessagesAttributesType;


}

const createChatMessages = async (data: ChatMessagesAttributesType): Promise<ChatMessagesAttributesType> => {
    return await ApiUtil.postWithToken(chatApiUrls.createChatMessagesUrl, data) as ChatMessagesAttributesType;

}

const createComplaintMessages = async (data: ChatMessagesAttributesType): Promise<ChatMessagesAttributesType> => {
    return await ApiUtil.postWithToken(chatApiUrls.createComplaintMessagesUrl, data) as ChatMessagesAttributesType;

}




const uploadChatImage = async (imageSrc: string | Blob, userId: number): Promise<unknown> =>
    await
        new Promise((resolve, reject) => {

            const formData = new FormData();

            formData.append('chat_image', imageSrc);
            formData.append('userId', userId.toString());

            ApiUtil.postWithToken(`${String(chatApiUrls.uploadChatImageUrl)}`, formData)
                .then((res) => {
                    resolve(res)
                }).catch((error) => { reject(error); })
        })


const getEmailListService = async (emailSearch: string): Promise<{ emailInfo: [string] }> => {
    const emailList = await ApiUtil.getWithToken(`${String(chatApiUrls.getEmailListServiceUrl)}/${emailSearch}`) as { emailInfo: [string] };
    return emailList;
}

const getAllOrgCompanyNameService = async (): Promise<{ companyInfo: [string] }> => {
    const companyList = await ApiUtil.getWithToken(`${String(chatApiUrls.getOrgCompanyListServiceUrl)}`) as { companyInfo: [string] };
    return companyList;
}

const createGroupChatConversation = async (
    body: addChatConversationType,
): Promise<unknown> => {
    return await new Promise((resolve, reject): void => {

        ApiUtil.postWithToken(
            `${String(chatApiUrls.createGroupChatConversationUrl)}`,
            body,
        ).then((response) => {
            resolve(response)
        }).catch((error) => { reject(error); })
    });
};

export {
    createChatConversation,
    getAllConversation,
    readChatConversation,
    getConversationById,
    getAllChatByConversationId,
    createChatMessages,
    createComplaintMessages,
    uploadChatImage,
    updateConversationStatus,
    getAllChatByComplaintId,
    getConversationByConverId,
    getEmailListService,
    createGroupChatConversation,
    getAllMessagesByConversationId,
    getAllOrgCompanyNameService
}